import { Button, Paper } from "@mui/material";
import { AnimalSelect } from "./AnimalSelect";
import { useState } from "react";
import { CountText } from "./CountText";
import { DateText } from "./DateText";
import { UserMenu } from "./UserMenu";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationSlice";

export const Sandbox = props => {

    const [animal, setAnimal] = useState();
    const dispatch = useDispatch();

    const handleOnChange = (_, value) => {
        setAnimal(value);
    }

    const handleSubmit = e => {
        e.preventDefault();
    }

    const handleTest = () => {
        dispatch(addNotification({
            message: "This is a test",
            type: "success",
        }));
    }

    return (
        <Paper sx={{
            padding: "16px",
            display: "flex",
            gap: "8px",
            flexDirection: "column",
        }}>
            <h1>Sandbox</h1>
            <form onSubmit={handleSubmit}>
                <AnimalSelect id="animals" onChange={handleOnChange} />
                <Button type="submit" variant="contained">Submit</Button>
            </form>
            <CountText num={123} />
            <CountText num={1234} />
            <CountText num={5_123_234} />
            <CountText num={1_115_123_234} />
            <DateText date={new Date()} />
            <UserMenu user={{
                name: "test",
            }} />
            <Button onClick={handleTest}>Tester</Button>
        </Paper>
    );
}